import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9412650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = { class: "custom-radio-group" }
const _hoisted_3 = { class: "wrap-radio" }
const _hoisted_4 = { class: "wrap-radio" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  class: "detail-svg",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2900_2212)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z",
      fill: "black",
      "fill-opacity": "0.45"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.24976 4.25C6.24976 4.44891 6.32877 4.63968 6.46943 4.78033C6.61008 4.92098 6.80084 5 6.99976 5C7.19867 5 7.38943 4.92098 7.53009 4.78033C7.67074 4.63968 7.74976 4.44891 7.74976 4.25C7.74976 4.05109 7.67074 3.86032 7.53009 3.71967C7.38943 3.57902 7.19867 3.5 6.99976 3.5C6.80084 3.5 6.61008 3.57902 6.46943 3.71967C6.32877 3.86032 6.24976 4.05109 6.24976 4.25ZM7.37476 6H6.62476C6.55601 6 6.49976 6.05625 6.49976 6.125V10.375C6.49976 10.4438 6.55601 10.5 6.62476 10.5H7.37476C7.44351 10.5 7.49976 10.4438 7.49976 10.375V6.125C7.49976 6.05625 7.44351 6 7.37476 6Z",
      fill: "black",
      "fill-opacity": "0.45"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2900_2212" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "14",
        height: "14",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_6 = { class: "save-btn" }
const _hoisted_7 = { class: "save-after" }

import { ref, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import ModalConfirmReceipt from './ModalConfirmReceipt.vue'
import { ASK_ENUM, DEFAULT_RECETIPT_BOOK_VALUE, GetUserConfigResProps, responseReceiptData } from './utils'

/** 获取店铺配置 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getSignUpValue, setSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)

/** 是否询问 默认不询问 */
const isAsk = ref(ASK_ENUM.ASK)

// 零售书内容
const receiptInputContent = ref('')
/** 是否在请求中 */
const httpRequestRef = ref(false)
/** 隐私协议是否同意 */
const agreeProtocol = ref(false)
/** 点击确定触发协议回调 */
const submitFuncGoBack = ref<() => void>()

onMounted(async () => {
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  isAsk.value = lastUseData.askEveryTime
  receiptInputContent.value = lastUseData.content
})

/** 协议modal */
const modalConfirmReceiptRef = ref<InstanceType<typeof ModalConfirmReceipt>>()

const handleAsk = (value: ASK_ENUM) => {
  isAsk.value = value
}

const agreeSubmit = async () => {
  if (!agreeProtocol.value) {
    submitFuncGoBack.value = agreeSubmit
    modalConfirmReceiptRef.value?.open()
    return
  }
  if (isAsk.value === ASK_ENUM.NO_ASK && receiptInputContent.value.trim().length === 0) {
    ElMessage.error(t('请输入内容'))
    return
  }

  if (httpRequestRef.value) {
    return
  }

  httpRequestRef.value = true

  const payload: GetUserConfigResProps = {
    askEveryTime: isAsk.value,
    content: receiptInputContent.value
  }
  const res = await setSignUpValue(JSON.stringify(payload))
  ElMessage.success(t('修改成功'))
  httpRequestRef.value = false
}

const protocolModalOpen = (protocolStatus: boolean) => {
  agreeProtocol.value = protocolStatus
  submitFuncGoBack.value?.()
}

const protocolBack = () => {
  submitFuncGoBack.value = undefined
  modalConfirmReceiptRef.value?.open()
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_radio_group, { "model-value": isAsk.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_radio, {
                  label: _unref(ASK_ENUM).ASK,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAsk(_unref(ASK_ENUM).ASK)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("领受书抬头设定每次询问")), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_radio, {
                  label: _unref(ASK_ENUM).NO_ASK,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAsk(_unref(ASK_ENUM).NO_ASK)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("不询问")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "light",
                  style: {"font-size":"14px","line-height":"22px","font-weight":"400"},
                  content: _unref(t)('设置完后，每次下载都使用该抬头，不再询问'),
                  placement: "top-start"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["content"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      (isAsk.value === _unref(ASK_ENUM).NO_ASK)
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            class: "receipt-input",
            modelValue: receiptInputContent.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((receiptInputContent).value = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_button, {
        onClick: agreeSubmit,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("span", {
        class: "disclaimer",
        onClick: protocolBack
      }, _toDisplayString(_unref(t)('免责声明')) + " >", 1)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('保存前请先阅读免责声明')), 1),
    _createVNode(ModalConfirmReceipt, {
      onOk: protocolModalOpen,
      ref: (_value, _refs) => {
        _refs['modalConfirmReceiptRef'] = _value
        modalConfirmReceiptRef.value = _value
      }
    }, null, 512)
  ]))
}
}

})